export default __webpack_public_path__ + "static/media/Fronic_Logo_white.27f34786.png";